import * as React from 'react';

import { V2ActionGutterHiddenContext, V2LayoutContext } from './V2LayoutContext';

export const useIsV2Layout = (): boolean => React.useContext(V2LayoutContext);

/** See `V2ActionGutterHiddenContext`. Only meaningful under `useIsV2Layout()`. */
export const useIsV2ActionGutterHidden = (): boolean =>
  React.useContext(V2ActionGutterHiddenContext);
